import * as x from '../helpers/xmlHelpers';

export class MarketDetail {
    constructor(doc)
    {
		this.label = null
		this.marketBoundariesDescription = null
		this.marketInventoryLookbackMonthsCount = null
		this.marketInventorySearchParameterDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.marketBoundariesDescription = x.getStringElement(doc, "./ns:MarketBoundariesDescription");
		this.marketInventoryLookbackMonthsCount = x.getIntegerElement(doc, "./ns:MarketInventoryLookbackMonthsCount");
		this.marketInventorySearchParameterDescription = x.getStringElement(doc, "./ns:MarketInventorySearchParameterDescription");
   }
}

export class MarketInventory {
    constructor(doc)
    {
		this.label = null
		this.marketInventoryCount = null
		this.marketInventoryHighestPriceAmount = null;
		this.marketInventoryLowestPriceAmount = null;
		this.marketInventoryMedianDaysOnMarketCount = null
		this.marketInventoryMedianPriceAmount = null;
		this.marketInventoryType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.marketInventoryCount = x.getIntegerElement(doc, "./ns:MarketInventoryCount");
		this.marketInventoryHighestPriceAmount  = x.getMISMOAmountElement(doc, "./ns:MarketInventoryHighestPriceAmount");
		this.marketInventoryLowestPriceAmount  = x.getMISMOAmountElement(doc, "./ns:MarketInventoryLowestPriceAmount");
		this.marketInventoryMedianDaysOnMarketCount = x.getIntegerElement(doc, "./ns:MarketInventoryMedianDaysOnMarketCount");
		this.marketInventoryMedianPriceAmount  = x.getMISMOAmountElement(doc, "./ns:MarketInventoryMedianPriceAmount");
		this.marketInventoryType = x.getStringElement(doc, "./ns:MarketInventoryType");
   }
}

export class MarketTrend {
    constructor(doc)
    {
		this.label = null
		this.marketingTimeType = null
		this.marketSupplyTrendType = null
		this.marketTrendsForeclosureActivityIndicator = null
		this.priceTrendsAnalysisDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.marketingTimeType = x.getStringElement(doc, "./ns:MarketingTimeType");
		this.marketSupplyTrendType = x.getStringElement(doc, "./ns:MarketSupplyTrendType");
		this.marketTrendsForeclosureActivityIndicator = x.getBooleanElement(doc, "./ns:MarketTrendsForeclosureActivityIndicator");
		this.priceTrendsAnalysisDescription = x.getStringElement(doc, "./ns:PriceTrendsAnalysisDescription");
   }
}

export class Market {
    constructor(doc)
    {
		this.label = null
		this.marketDetail = null
		this.marketInventories = []
		this.marketTrend = null
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:MARKET_DETAIL");
		if (node !== null)
				this.marketDetail = new MarketDetail(node);
		nodes = x.selectNodes(doc, "./ns:MARKET_INVENTORIES/ns:MARKET_INVENTORY");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.marketInventories.push(new MarketInventory(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:MARKET_TREND");
		if (node !== null)
				this.marketTrend = new MarketTrend(node);
   }

	GetMarketInventory(type) {
	for(var mi of this.marketInventories)
		if (type === mi.marketInventoryType) return mi;

	return null;
	}

}
